import { Injectable } from "@angular/core";
import { ApplicationInsightsService } from "./application-insights.service";
import { IErrorService } from "@microsoft/applicationinsights-angularplugin-js";

@Injectable()
export class ErrorHandlerService implements IErrorService {
  constructor(
    // private applicationInsightsService: ApplicationInsightsService
  ) {}

  // ApplicationInsights
  handleError(error: any) {
    const customErro: Error = new Error();
    customErro.name = ` ${error?.name}`;
    customErro.stack = ` ${error?.stack}`;
    customErro.message = `App-SVM-Error: ${error?.message}`;
    console.error(customErro.message, error);
    // this.applicationInsightsService.logException(customErro);
  }
}
